import { PersistentUserCatalogSearchState } from './PersistentData';

export function addQueryToSearchHistory(
  history: PersistentUserCatalogSearchState['history'],
  query: string
) {
  const historyList = [...history];
  // 追加予定のクエリの文字列と完全一致するhistoryが存在するかを見る
  const sameQueryIndex = historyList.findIndex(item => item.query === query);
  const additionalQuery = { query };

  // 追加予定のクエリが履歴に存在する場合は取り除く
  if (sameQueryIndex !== -1) {
    historyList.splice(sameQueryIndex, 1);
  }
  return [additionalQuery, ...historyList];
}
